import React from "react";
import { getSystemVersion } from "../../../shared/utils/system-version.utils";

export const SystemVersion = React.memo(function SystemVersion(): React.ReactElement {
    return <>{getSystemVersion()}</>;
});
